import {
  React,
  Component
} from 'react';
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation
} from "react-router-dom";

import PageNotFound from '@pages/PageNotFound';
import Logout from '@pages/Logout';
import Home from '@pages/Home';
import About from '@pages/About';
import Research from '@pages/Research';
import FrequentlyAskedQuestions from '@pages/FrequentlyAskedQuestions';
import GetStarted from '@pages/GetStarted';
import Login from '@pages/Login';
import ResearcherDashboard from '@pages/ResearcherDashboard';
import { default as ResearcherDashboardOverview } from '@pages/ResearcherDashboard/pages/Dashboard';
import Datacapture from '@pages/ResearcherDashboard/pages/Datacapture';
import Despatch from '@pages/ResearcherDashboard/pages/Despatch';
import DataUpdate from '@pages/ResearcherDashboard/pages/DataUpdate';
import FieldworkTracking from '@pages/ResearcherDashboard/pages/Fieldwork/Tracking/FieldworkTracking';
import FieldworkReporting from '@pages/ResearcherDashboard/pages/Fieldwork/Reporting/FieldworkReporting';
import PreviousSurveys from '@pages/ResearcherDashboard/pages/PreviousSurveys';
import Institutions from '@pages/ResearcherDashboard/pages/Institutions';
import RespondentUsers from '@pages/ResearcherDashboard/pages/Users/RespondentUsers/RespondentUsers';
import ResearcherUsers from '@pages/ResearcherDashboard/pages/Users/ResearcherUsers/ResearcherUsers';
import RolesManagement from '@pages/ResearcherDashboard/pages/RolesManagement';
import PermissionsManagement from '@pages/ResearcherDashboard/pages/PermissionsManagement';
import RespondentDashboard from '@pages/RespondentDashboard';
import { default as RespondentDashboardOverview } from '@pages/RespondentDashboard/pages/Dashboard';
import Mandate from '@pages/RespondentDashboard/pages/Mandate';
import SurveyLanding from '@pages/RespondentDashboard/pages/SurveyLanding';
import Survey from '@pages/RespondentDashboard/pages/Survey';
import { default as RespondentPreviousSurveys } from '@pages/RespondentDashboard/pages/PreviousSurvey';
import { default as RespondentResearch } from '@pages/RespondentDashboard/pages/Research';
import RespondentProfile from '@pages/RespondentDashboard/pages/Profile/RespondentProfile';
import ResearcherProfile from '@pages/ResearcherDashboard/pages/Profile/ResearcherProfile';
import SurveyCycles from '@pages/ResearcherDashboard/pages/SystemAdministration/SurveyCycles/SurveyCycles';
import CopyRegister from '@pages/ResearcherDashboard/pages/SystemAdministration/CopyRegister/CopyRegister';
import ConfidentialityQuestions from '@pages/ConfidentialityQuestions';

import '@styles/style.css';

class App extends Component {

  render() {
    return (
      <div className="App">
        <BrowserRouter >
          <Routes>

            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/research" element={<Research />} />
            <Route path="/faq" element={<FrequentlyAskedQuestions />} />
            <Route path="/expressinterest" exact element={<GetStarted />} />
            <Route path="/confidentiality" exact element={<ConfidentialityQuestions />} />
            <Route path="/login" element={<LoginWithParams />} />
            <Route path="/logout" element={<Logout />} />
            
            <Route roles={['dsp_researcher']} path="/researcherdashboard" element={<ResearcherDashboard />}>
              <Route path="overview" element={<ResearcherDashboardOverview />} />
              <Route path="despatch" element={<Despatch />} />
              <Route path="datacapture" element={<Datacapture />} />
              <Route path="dataupdate" element={<DataUpdate />} />
              <Route path="fieldworktracking" element={<FieldworkTracking />} />
              <Route path="fieldworkreporting" element={<FieldworkReporting />} />
              <Route path="previous-surveys" element={<PreviousSurveys />} />
              <Route path="institutions" element={<Institutions />} />
              <Route path="manage-respondents" element={<RespondentUsers />} />
              <Route path="manage-researchers" element={<ResearcherUsers />} />
              <Route path="manage-roles" element={<RolesManagement />} />
              <Route path="manage-permissions" element={<PermissionsManagement />} />
              <Route path="survey-cycles" element={<SurveyCycles />} />
              <Route path="registers" element={<CopyRegister />} />
              <Route path="system-settings" element={<SurveyCycles />} />
              <Route path="profile" element={<ResearcherProfile />} />
            </Route>
            
            <Route roles={['dsp_respondent']} path="/respondentdashboard" element={<RespondentDashboard />}>
              <Route path="overview" element={<RespondentDashboardOverview />} />
              <Route path="mandate" element={<Mandate />} />
              <Route path="survey-landing" element={<SurveyLanding />} />
              <Route path="survey" element={<Survey />} />
              <Route path="previous-surveys" element={<RespondentPreviousSurveys />} />
              <Route path="research" element={<RespondentResearch />} />
              <Route path="profile" element={<RespondentProfile />} />
            </Route>

            <Route path="*" element={<PageNotFound />} />

          </Routes>
        </BrowserRouter>
      </div>
    );
  }

}

export default App;

export function LoginWithParams() {

  const search = useLocation().search;

  let prepop = new URLSearchParams(search).get('prepop');
  let username = new URLSearchParams(search).get('username');

  if (prepop !== undefined && prepop !== null && prepop === 'true') {
    return <Login prepop={JSON.parse(prepop)} username={username} />;
  } else {
    return <Login />
  }

}